export default __webpack_public_path__ + "images/Irish.ca9ecc.jpg";